import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import Ecoz from "../components/register/ecoz";
import {service} from "../utils/constant";
import Home from '../components/home';


const OpenRoute = () => {
 if(service==="ecoz") 
    { 
        return (        
           
             <Routes>
             <Route exact path='/' element={<Home/>} /> 
             <Route path='/home' element={<Home/>} />             
             <Route path='/register' element={<Ecoz/>}  />
             <Route path='/login' element={<Ecoz/>} />
             <Route path='*' element={<Navigate to="/register" />} /> 
         </Routes>
        )
    }

};

export default OpenRoute;